import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { slideInAnimation } from 'src/app/route-animate';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
interface incub {
  id: string;
  incubatorName: string;
}
interface incubDis {
  district: string;
}
@Component({
  selector: 'app-incubators-list',
  templateUrl: './incubators-list.component.html',
  styleUrls: ['./incubators-list.component.css'],
  animations: [slideInAnimation],
})
export class IncubatorsListComponent implements OnInit {
  [x: string]: any;

  searchForm: FormGroup;
  private searchApi = environment.url + environment.searchIncubator;
  private nameListApi = environment.url + environment.incubatorNameList;
  /**
   * Constructs a new instance of the IncubatorsListComponent.
   * @param httpClient The HTTP client to make API calls.
   * @param route The route object.
   * @param fb The form builder to create the search form.
   * @param makeapi The API service to make API calls.
   * @param getdata The value service to get the values.
   */
  constructor(
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService
  ) {
    /**
     * Creates a form group with the search form fields.
     * The fields are:
     * - incubatorName: The name of the incubator.
     * - incubatorYearofEstd: The year of establishment of the incubator.
     * - incubatorDistrict: The district of the incubator.
     * - incubatorFocusedSector: The focused sector of the incubator.
     */
    this.searchForm = this.fb.group({
      incubatorName: [''],
      incubatorYearofEstd: [''],
      incubatorDistrict: [''],
      incubatorFocusedSector: [''],
    });
  }
  /**
   * Called when a key is pressed.
   * Prevents the input of any special characters.
   * @param event The event object.
   */
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const regex = new RegExp('^[a-zA-Z0-9_]+$'); // Regex to allow only alphanumeric characters and underscores
    const inputChar = String.fromCharCode(event.charCode);
    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it doesn't match the regex
    }
  }
  sample;
  /**
   * Called when the component is initialized.
   * Sets the CSS file for the component.
   * Calls the APIs to fetch the incubator names, year of establishment, district list, and resets the search form.
   * Subscribes to the query params and filters the incubators based on the selected district.
   */
  ngOnInit(): void {
    // Set the CSS file for the component
    document.getElementById('css').setAttribute('href', 'assets/css/home.css');
    // Make the source visible
    this.getdata.isVisibleSource.next(true);
    // Fetch the incubator names
    this.incubatorNameApi();
    // Fetch the year of establishment
    this.yearGetList();
    // Fetch the district list
    this.districtList();
    // Reset the search form
    this.restList();
    // Make the source visible
    this.getdata.isVisibleSource.next(true);
    // Subscribe to the query params and filter the incubators based on the selected district
    this.route.queryParams
      .pipe(filter((params) => params._districtname))
      .subscribe((params) => {
        let getform = this.searchForm.value;
        // Set the selected district in the search form
        getform.incubatorDistrict = params._districtname;
        // Update the search form with the selected district
        this.searchForm.patchValue(getform);
        // Call the selectIncubator function with the selected district
        this.selectIncubator(params._districtname);
      });
  }

  districtValues = [];
  /**
   * Fetches the district list from the local JSON file and updates the district values.
   * Calls the filterIncubetorDistrict function to initialize the district filtering.
   */
  districtList() {
    // Make an HTTP GET request to fetch the district data from the JSON file
    this.httpClient.get<any>('assets/json/district.json').subscribe((data) => {
      // Store the received data in the districtValues array
      this.districtValues = data;

      // Set the incubatorDistrictList to the fetched district values
      this.incubatorDistrictList = this.districtValues;

      // Call the function to filter the district list based on user input
      this.filterIncubetorDistrict();
    });
  }
  namePush = [];
  /**
   * Fetches the list of incubator names from the server.
   * The list is stored in the `incubatorNameList` property and
   * the initial value of the incubator name select is set.
   */
  incubatorNameApi() {
    // Make a POST request to retrieve the list of incubator names
    this.makeapi
      .method(this.nameListApi, '', 'postunauth')
      .subscribe((data) => {
        // Store the retrieved incubator names
        this.incubatorNameList = data;
        // Set the initial value of the incubator name select
        this.filterIncubetor();
      });
  }
  yearData = [];
  /**
   * Populate the yearData list with the years from the current year to 1978.
   *
   * Loops through each year from the current year down to 1978 and adds
   * the year to the list if it is greater than or equal to 1978.
   */
  yearGetList() {
    let val = 1978;
    const d = new Date();
    let year = d.getFullYear();
    for (let i = year; i >= val; i--) {
      if (val <= i) {
        // Add the year to the list if it is greater than or equal to 1978
        let req = {
          incubatorYearofEstd: i,
        };
        this.yearData.push(req);
      }
    }
  }
  searchValue = false;
  searchList = [];
  list: any = {};

  /**
   * Updates the search form value and fetches the updated list of incubators.
   * If the selected value is not empty, sets the searchValue to true.
   * Initializes the list object with the current page number and size, then calls the ListApi function
   * to refresh the list of incubators.
   *
   * @param value The selected value from the dropdown.
   */
  selectIncubator(value) {
    if (value != '') {
      this.searchValue = true;
    }

    this.searchList = [];
    let getform = this.searchForm.value;
    this.list = {
      incubatorName: getform.incubatorName,
      incubatorYearofEstd: getform.incubatorYearofEstd,
      incubatorDistrict: getform.incubatorDistrict,
      incubatorFocusedSector: getform.incubatorFocusedSector,
      pageNumber: this.currentPage,
      listSize: this.currentPageCount,
    };

    this.listApi();
  }
  /**
   * Resets the list with the current pagination parameters and fetches the updated list of incubators.
   * Initializes the list object with the current page number and size, then calls the ListApi function
   * to refresh the list of incubators.
   */
  restList() {
    // Initialize the list object with the current page number and size
    this.list = {
      pageNumber: this.currentPage,
      listSize: this.currentPageCount,
    };

    // Call the ListApi function to fetch the updated list of incubators
    this.listApi();
  }
  noData = true;
  /**
   * Fetches the list of incubators from the API using the current search
   * parameters and pagination.
   * Subscribes to the API response and updates the component's data fields
   * based on the response.
   */
  listApi() {
    // Show the loader while fetching data
    this.getdata.amizhthLoader('show');
    // Call the API to fetch the list of incubators
    this.makeapi
      .method(this.searchApi, this.list, 'postunauth')
      .subscribe((data) => {
        // Hide the loader after receiving data
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // If the count of data returned is not 0
          if (data.pageCount != 0) {
            // Hide the "No Data" message
            this.noData = false;
            // Update the page total count
            this.numberOfList = data.listSize;
            // Update the total pages
            this.totalPages = data.pageCount;
            // Update the count of items
            this.countList = data.incubators.length;
            // Calculate the count of items and update pagination counts
            if (
              this.currentPage == this.totalPages &&
              this.countList != this.numberOfList
            ) {
              this.startCount = this.startCount + this.currentPageCount;
              this.EndCount = this.numberOfList;
            } else if (this.countList == this.numberOfList) {
              this.startCount = 1;
              this.EndCount = this.numberOfList;
            }
            // Update the search results
            this.searchList = data.incubators;
          } else {
            // If the count is 0, show the "No Data" message
            this.noData = true;
            // Clear the search results
            this.searchList = [];
          }
        } else {
          // If the response was not successful, show the "No Data" message
          this.noData = true;
          // Clear the search results
          this.searchList = [];
        }
      });
  }
  /**
   * Navigates to the incubator details page.
   * @param incubatorName The name of the incubator to view details for.
   */
  viewDetails(incubatorName) {
    // Call the service to navigate to the incubator details page with the given incubator name
    this.getdata.incubatorId(incubatorName);
  }
  /**
   * Resets the search form and clears the search results.
   */
  clearBtn() {
    // Reset the search form
    this.searchForm.reset();
    // Clear the search results
    this.searchList = [];
    // Reset the search value
    this.searchValue = false;
    // Call the list API with default parameters
    this.restList();
    // Navigate to the incubators page
    // this.router.navigateByUrl('/incubators')
  }
  // Search
  /**
   * Cleans up the component by unsubscribing from the onDestroy observable.
   * This prevents memory leaks when the component is destroyed.
   */
  ngOnDestroy() {
    // Unsubscribe from any subscriptions
    this._onDestroy.next();
    // Complete the subject
    this._onDestroy.complete();
    // Unsubscribe from any subscriptions
    this._onDisDestroy.next();
    // Complete the subject
    this._onDisDestroy.complete();
  }
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  // incubater search
  protected incubatorNameList: incub[] = [];
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  protected _onDestroy = new Subject();
  /**
   * Sets the initial value of the incubator name select control and filters the list
   * of incubator names based on the user's input.
   * Subscribes to the value changes of the filter control and calls this.filterBanks
   * whenever the value changes.
   */
  filterIncubetor() {
    // Set the initial value of the incubatorName select control
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Set the initial value of the incubator list
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to the value changes of the filter control
    // When the value changes, call the filterBanks function
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });
  }
  /**
   * Filters the list of incubator names based on the value of the filter control.
   * Subscribes to the value changes of the filter control and calls this function
   * whenever the value changes.
   * If no search term is provided, the full list is returned.
   */
  protected filterBanks() {
    let search = this.incubatorFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list of incubator names
      this.incubatorListValue.next(this.incubatorNameList.slice());
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      search = search.toLowerCase();
    }

    // Filter the incubator name list based on the search term and update the list value
    this.incubatorListValue.next(
      this.incubatorNameList.filter(
        (val) => val.incubatorName.toLowerCase().indexOf(search) > -1
      )
    );
  }
  // district search
  protected incubatorDistrictList: incubDis[] = [];
  public incubatorDistrict: FormControl = new FormControl();
  public incubatorDistrictFilterCtrl: FormControl = new FormControl();
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected _onDisDestroy = new Subject();
  @ViewChild('DistrictSelect', { static: true }) DistrictSelect: MatSelect;
  /**
   * Sets the initial value of the incubator district select control and filters the list
   * of incubator districts based on the user's input.
   * Subscribes to the value changes of the filter control and calls the
   * filterDistrict function whenever the value changes.
   */
  filterIncubetorDistrict() {
    // Set the default value of the district select control to the first element in the list
    this.incubatorDistrict.setValue(this.incubatorDistrictList[1]);

    // Set the initial value of the incubator district list
    this.incubatorDistrictListValue.next(this.incubatorDistrictList);

    // Subscribe to the value changes of the filter control
    this.incubatorDistrictFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDisDestroy))
      .subscribe(() => {
        // Call the filterDistrict function whenever the value of the filter control changes
        this.filterDistrict();
      });
  }
  /**
   * Filters the incubator district list based on the search term from the filter control.
   * If no search term is provided, returns the full list of incubator districts.
   */
  protected filterDistrict() {
    if (!this.incubatorDistrictList) {
      // If the incubator district list is not available, return immediately
      return;
    }

    let search = this.incubatorDistrictFilterCtrl.value;
    if (!search) {
      // If no search term is provided, return the full list of incubator districts
      this.incubatorDistrictListValue.next(this.incubatorDistrictList.slice());
      return;
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      search = search.toLowerCase();
    }

    // Filter the incubator district list based on the search term and update the list value
    this.incubatorDistrictListValue.next(
      this.incubatorDistrictList.filter(
        (val) => val.district.toLowerCase().indexOf(search) > -1
      )
    );
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 9;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 9;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 9;
  countList = 0;
  /**
   * Handles pagination of the list.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page) {
    // Show the pagination controls
    this.show_page = true;

    // If navigating to the previous page and not on the first page
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;

      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Clear the search value
        this.searchValue = false;

        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;

        // Update the pagination count
        this.paginationCount = prevcount;

        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }

      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        // Decrement the start count
        this.startCount = this.startCount - this.currentPageCount;

        // Decrement the end count
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;

      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Clear the search value
        this.searchValue = false;

        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;

        // Update the pagination count
        this.paginationCount = nextcount;
      }

      // If the user is not on the last page
      if (this.currentPage != this.totalPages) {
        // Increment the start and end counts for the new page
        this.startCount = this.startCount + this.currentPageCount;
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }

    // Clear the selected incubator
    this.selectIncubator('');
  }
 viewIncubateesList() {
  const downloadLink = document.createElement('a');
  downloadLink.href = './assets/pdf/Incubatees_list.xlsx';  // ✅ correct extension
  downloadLink.download = 'incubateesList.xlsx';           // ✅ correct extension

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

}
